export const ONBOARDING_FORM_STAGE = {
  STAGE_0: 'STAGE_0',
  STAGE_1: 'STAGE_1',
  STAGE_2: 'STAGE_2',
  STAGE_2FA_METHOD: 'STAGE_2FA_METHOD',
  STAGE_3: 'STAGE_3',
};
